module.exports = __webpack_public_path__ + "assets/img/user-5.6129ec49.jpg";